import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useForm } from "react-hook-form";
import { useHistory } from 'react-router-dom';
import TitleHeader from './titleHeader';
import Step from "../Components/FormElements/step";
import imageUser from "../Resources/svg/image-user-woman.svg";
import { validatorField } from "../Utils/validators";
import { getQuizIndexParent } from "../Utils/utils";
import ErrorCustom from "../Components/errorCustom";
import { addHealthStatement } from "../Store/simulate/actions";
import useBeforeFirstRender from '../customHook/useBeforFirstRender';

export default function HealthStatement() {
  const dataStore = useSelector(state => state.simulate.policy.healthStatement);
  const dataQuiz = useSelector(state => state.quiz.quizDPS);
  const dataClient = useSelector(state => state.simulate.policy.client);
  const client = dataClient.datosCliente;
  const dispatch = useDispatch();
  const { handleSubmit, register, errors } = useForm();
  const history = useHistory();

  const [questions, setQuestions] = useState([]);

  useEffect(() => {
    if (dataStore.length > 0) {
      setQuestions(dataStore);
    } else {
      const dataQuestions = dataQuiz.filter(item => item.sk !== 'DPS#AS');
      dataQuestions.map((item, i) => {
        const index = getQuizIndexParent(dataQuiz, i);
        item.value = null;
        item.parent = index;
        item.show = true;
      });
      setQuestions(dataQuestions);
    }
  }, []);

  const navigationPrev = () => {
    history.push('/simulaciones/datos-laborales');
  };

  const setValueQuestions = (index, value) => {
    let clon = [...questions];
    clon[index].value = value;
    if (typeof value === 'boolean') {
      clon.forEach(item => {
        if (item.parent === index) {
          item.value = null;
          item.show = value;
        }
      });
    }
    setQuestions(clon);
  };

  const checkActive = (index) => {
    let parent = questions[index].entityData.split('.');
    parent = parent.slice(0, -1);
    parent = parent.join('.');

    const parentItem = questions.find(item => item.entityData === parent);
    if (!parentItem) {
      return 'hidden';
    }
    return !parentItem.value ? 'hidden' : 'show';
  };

  const handleChange = (e, index) => {
    const { value } = e.target;
    setValueQuestions(index, value);
  };

  const navigationNext = () => {
    history.push('/simulaciones/beneficiarios');
  };

  const onSubmit = data => {
    dispatch(addHealthStatement(questions));
    navigationNext();
  };

  useBeforeFirstRender(client);

  return (
    <div className="container">
      <div className="healthStatement">
        <div className="column">
          <Step handleClick={() => navigationPrev()} step="3" total="7"/>
            <TitleHeader 
              title="Declaración de"
              titleBold="salud"
              subtitle="Necesitamos registrar estos datos"
            />
          <form className="questionsForm healthStatement__form" onSubmit={handleSubmit(onSubmit)}>
            {questions.map((question, index) => (
              <div key={index}>
                {question.questionType === 'boolean' && 
                  <div className={`question${index === 0 ? ' not-border' : ''}`}>
                    <div className="question__title sm">
                      {question.entityData} {question.title}
                    </div>
                    <div className="question__control__button">
                      <a 
                        className={`buttonCustom white sm${!question.value ? '' : ' active'}`} 
                        onClick={() => setValueQuestions(index, true)}
                      >SI</a>
                      <a 
                        className={`buttonCustom white sm${question.value === false ? ' active' : ''}`} 
                        onClick={() => setValueQuestions(index, false)}
                      >NO</a>
                      <input 
                        type="hidden" 
                        id={question.sk}
                        name={question.sk}
                        ref={register({ validate: validatorField })} 
                        defaultValue={question.value === true ? 'SI' : (question.value === false ? 'NO' : '')}
                        />
                      <ErrorCustom errors={errors} name={question.sk} />
                    </div>
                  </div>
                }
                {(question.questionType === 'input' && question.show) && 
                  <div className={`question noTitle${questions[index].parent !== null ? ' child' : ''} ${checkActive(index)}`}>
                    {!!question.title && 
                      <div className="question__title"></div>
                    }
                    <div className="question__control input-field">
                      <input
                        className={errors[question.sk] ? 'error' : ''}
                        id={question.sk}
                        name={question.sk}
                        type="text"
                        autoComplete="off"
                        ref={register({ validate: checkActive(index) === 'show' ? validatorField : null })}
                        defaultValue={question.value || ''} 
                        onChange={e => handleChange(e, index)}
                        maxLength={question.metadata.maxLength || '100'}
                      />
                      <label className={question.value ? 'active' : ''} htmlFor={question.sk}>{question.metadata.placeholder}</label>
                      <ErrorCustom errors={errors} name={question.sk} />
                    </div>
                  </div>
                }
                {(question.questionType === 'date' && question.show) && 
                  <div className={`question noTitle${questions[index].parent !== null ? ' child' : ''} ${checkActive(index)}`}>
                    {!!question.title && 
                      <div className="question__title"></div>
                    }
                    <div className="question__control input-field">
                      <input
                        className={errors[question.sk] ? 'error' : ''}
                        id={question.sk}
                        name={question.sk}
                        type="text"
                        autoComplete="off"
                        ref={register({ validate: checkActive(index) === 'show' ? validatorField : null })}
                        defaultValue={question.value || ''}
                        onChange={e => handleChange(e, index)}
                        maxLength={question.metadata.maxLength || '20'}
                      />
                      <label className={question.value ? 'active' : ''} htmlFor={question.sk}>{question.metadata.placeholder}</label>
                      <ErrorCustom errors={errors} name={question.sk} />
                    </div>
                  </div>
                }
              </div>
            ))}
            <div className="contentButton">
              <button
                type="submit" 
                className="buttonCustom md"
                >Continuar</button>
            </div>
          </form>
        </div>
        <div className="column-image">
          <img src={imageUser}/> 
        </div>
      </div>
    </div>
  );
}
